import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  select(event) {
    const path = event.detail.value;
    window.location.href = path;
  }
}
